import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, IconButton } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { setAllThemes } from '../../redux/reducers/themeReducer';
import { deleteTheme, getThemes } from '../../services/apiService';

class SessionBuilder extends Component {
  constructor() {
    super();

    this.state = {
      deleteThemePopUp: null,
      isDeleting: false,
    };
  }

  componentDidMount = async () => {
    this.props.dispatch(setAllThemes(await getThemes()));
  };

  deleteThemeHandler = async (themeId) => {
    this.setState({ isDeleting: true });
    try {
      await deleteTheme(themeId);
      await this.componentDidMount();
    } catch (err) {
      console.error(err);
      toast.error('Deleting Theme Failed, Please try again later!', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
    this.setState({ isDeleting: false, deleteThemePopUp: null });
  };

  render = () => {
    return (
      <div>
        <header className='flex items-center gap-8'>
          <h1 className='text-3xl font-semibold'>Session Builder</h1>

          <Link
            to='/new-session'
            className='bg-white text-blue-c1 font-medium border border-blue-c1 rounded-md px-6 py-2'
          >
            Add New Theme
          </Link>
        </header>

        {this.props.themes && this.props.themes.length ? (
          <div className='inline-grid grid-cols-2 gap-4 mt-8'>
            {this.props.themes.map((theme) => (
              <div
                className='bg-white border-2 border-black border-opacity-20 rounded-xl flex justify-between gap-8 px-6 py-5'
                key={theme.id}
              >
                <span>
                  <h6 className='text-xl font-medium opacity-80'>
                    {theme.name}
                  </h6>
                  <div className='text-xs opacity-60 mt-1'>
                    Theme ID: {theme.id}
                  </div>
                </span>

                <span className='flex -mr-2'>
                  <Link
                    to={{
                      pathname: `/session-builder/edit-session/${theme.id}`,
                      state: { theme, isEditMode: true },
                    }}
                  >
                    <IconButton className='opacity-60 hover:opacity-100 hover:text-blue-c1'>
                      <Edit />
                    </IconButton>
                  </Link>

                  <span className='w-0.5 bg-black bg-opacity-10 my-2 mx-1' />

                  <IconButton
                    onClick={() => this.setState({ deleteThemePopUp: theme })}
                    className='opacity-60 hover:opacity-100 hover:text-red-500'
                  >
                    <Delete />
                  </IconButton>
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className='bg-white rounded-lg py-32 mt-8 flex items-center justify-center text-blue-c1'>
            <CircularProgress color='inherit' size='4rem' />
          </div>
        )}

        {this.state.deleteThemePopUp && (
          <div className='fixed inset-0 bg-black bg-opacity-25 flex'>
            <div className='m-auto bg-white rounded-lg text-center p-4'>
              <div className='text-2xl font-semibold opacity-80 pt-4'>
                Delete Theme ?
              </div>
              <div className='text-lg font-medium opacity-60 p-4'>
                Are you sure you want to delete `
                {this.state.deleteThemePopUp.name}` ?
              </div>

              <hr className='border-t border-black border-opacity-10 my-4' />

              <div className='text-right'>
                <button
                  className='opacity-40 font-medium rounded-md px-8 py-2'
                  disabled={this.state.isDeleting}
                  onClick={() => this.setState({ deleteThemePopUp: null })}
                >
                  Cancel
                </button>
                <button
                  className='bg-red-c1 text-white font-medium rounded-md py-2 w-32'
                  disabled={this.state.isDeleting}
                  onClick={() =>
                    this.deleteThemeHandler(this.state.deleteThemePopUp.id)
                  }
                >
                  {this.state.isDeleting ? (
                    <CircularProgress
                      color='inherit'
                      size='1.5rem'
                      className='-my-1.5'
                    />
                  ) : (
                    <span>Delete</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  themes: state.themeReducer.themes,
});

export default connect(mapStateToProps)(SessionBuilder);
